<template>
  <div class="card card-info" v-else>
    <div class="card-header">
      <h3 class="card-title" style="width: 100%">
        <button v-on:click="AddNew()" type="button" class=" float-left btn btn-sm btn-outline-secondary btn-default"> <i class="fa fa-plus"> Add New</i></button>
      </h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive">
            <table id="table" class="table table-bordered table-sm text-sm" width="100%">
              <thead class="bg-info">
                <tr>
                  <th>Department</th>
                  <th>Category</th>
                  <th>Session</th>
                  <th>Program</th>
                  <th>Name</th>
                  <th>Min. Aggr.</th>
                  <th>Max. Aggr.</th>
                  <th>Students</th>
                  <th width="30px">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, ind) in allMeritListRecord">
                  <td>{{item.DepartmentName}}</td>
                  <td>{{item.Category}}</td>
                  <td>{{item.SessionName}}</td>
                  <td align="center">{{item.ProgramName}}</td>
                  <td align="center">{{item.Name}}</td>
                  <td align="center">{{item.MinimumAggregate}}</td>
                  <td align="center">{{item.MaximumAggregate}}</td>
                  <td align="right">{{item.TotalStudents}}</td>
                  <td align="center" style="white-space: nowrap">
                    <div v-if="!item.Post">
                      <button class="btn btn-sm btn-primary" v-on:click="edit(item.MeritListID)">Edit</button>
                      <button class="btn btn-sm btn-success" v-on:click="lock(item.MeritListID, ind)">Lock</button>
                    </div>
                    <div v-else>
                      <button class="btn btn-sm btn-danger" v-on:click="unlock(item.MeritListID, ind)">Un-Lock</button>
                    </div>
                    <button class="btn btn-sm btn-warning" v-on:click="print(item.MeritListID)">Print</button>
                    <button class="btn btn-sm btn-info" v-on:click="ExtendDate(item.MeritListID)">Extend Date</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="mdlPatientRecord">
      <div class="modal-dialog ">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h4 class="modal-title">Date Extend</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Effective To *</label>
                  <input v-model="merit.EffectiveTo" type="date" class="form-control" />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer ">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>
            <button type="button" class="btn btn-success" v-on:click="updateDate()">
              Update
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>
<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        allMeritListRecord: [],
        merit : { EffectiveTo: '', MeritListID:'' },

      }
    },
    created: function () {
      this.pageLoad();
    },
    updated: function () {
        $('#table').DataTable();
    },
    methods: {
      print(interID) {
        var vm = this;
        startReq();
        axios.post('/api/AdmissionApi/printMeritList?ID=' + interID)
          .then(function (res) {
            endReq();
            window.open(res.data.url, '_blank');
          })
          .catch(function (error) {
            console.log(error);
          })
      },
      lock(interID, ind) {
        var vm = this;
        startReq();
        axios.post("/api/AdmissionApi/lockBtn?ID=" + interID)
          .then(function (res) {
            if (res.data.status) {
              endReq();
              toastr.success("Locked Successfully");
              vm.allMeritListRecord[ind].Post = true;
            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch(function (error) {

          });
      },
      unlock(interID, ind) {
        var vm = this;
        axios.post("/api/AdmissionApi/unlockBtn?ID=" + interID)
          .then(function (res) {
            if (res.data.status) {
              toastr.success("Un-Locked Successfully");
              vm.allMeritListRecord[ind].Post = false;
            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch(function (error) {
          });
      },
      pageLoad() {
        var vm = this;
        startReq();
        axios.get("/api/AdmissionApi/loadMeritList")
          .then(function (res) {
            endReq();
            if (res.data.status) {
              vm.allMeritListRecord = res.data.lst;
            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch(function (error) {

          });
      },
      AddNew() {
        window.location.href = "../Admission/NewMeritList";
      },
      edit(interID) {
        var vm = this;
        axios.post("/api/AdmissionApi/editMeritList?ID=" + interID)
          .then(function (res) {
            if (res.data.status) {
              window.open(res.data.url, '_blank');
            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch(function (error) {

          });
      },
      ExtendDate(interID) {
        var vm = this;
        axios.post("/api/AdmissionApi/extendDate?ID=" + interID)
          .then(function (res) {
            if (res.data.status) {
              vm.merit = res.data.merit;
              $('#mdlPatientRecord').modal('show');
            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch(function (error) {

          });
       
      },
      updateDate() {
        var vm = this;
        axios.post("/api/AdmissionApi/updateDateExtend?ID=" + vm.merit.MeritListID + "&EffectiveTo=" + vm.merit.EffectiveTo)
          .then(function (res) {
        
              toastr.success("Date Extended");
              $('#mdlPatientRecord').modal('close');
            
         
          })
          .catch(function (error) {

          });
      }

    }
  })
</script>



// WEBPACK FOOTER //
// src/components/onlineadmission/allMeritList.vue